module.exports = __webpack_public_path__ + "static/media/2020_composite.e771980c.jpg";